module.exports = __webpack_public_path__ + "img/_MG_4649-greeninger-cropped-compressed-mobile.814d6f4d.webp";